module.exports = __webpack_public_path__ + "img/life-at-ommax-11.d15abced.jpg";